module.exports = __webpack_public_path__ + "img/ic_national_emblem@2x.3df9768b.png";